import React, { useEffect } from "react";
import Header from "../components/landing/Header";
import HeroSection from "../components/landing/HeroSection";
import ComparisonSection from "../components/landing/ComparisonSection";
import ScientificBackSection from "../components/landing/ScientificBackSection";
import GoogleCalendarSection from "../components/landing/GoogleCalendarSection";
import NotificationsSection from "../components/landing/NotificationsSection";
import PricingSection from "../components/landing/PricingSection";
import FAQSection from "../components/landing/FAQSection";
import Footer from "../components/landing/Footer";
import styles from "../styles/landing.module.css";

const LandingPage = () => {
  useEffect(() => {
    // Définir le titre de la page
    document.title = "Memory Curve";
  }, []);

  return (
    <div className={styles.landingPage} id="top">
      <Header />
      <main>
        <HeroSection />
        <ComparisonSection />
        <ScientificBackSection id="scientific-back" />
        <GoogleCalendarSection />
        <NotificationsSection />
        <PricingSection id="pricing" />
        <FAQSection id="faq" />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage; 